import OutreachBase from "./OutreachBase";
import { kompakt } from "@/pages/admin/budsjett/budsjettUtils";
import { SPONSOR_STAGES, SPONSOR_STAGE_LABEL, sponsorStageFarge } from "./eventosUtils";

const SP_INDEX = Object.fromEntries(SPONSOR_STAGES.map((s, i) => [s.k, i]));

export function partnerGruppeFor(p) {
  if (p.stage === "declined" || p.signal === "no") return "no";
  if (p.signal === "maybe") return "maybe";
  if (p.signal === "yes" || p.stage === "verbal" || p.stage === "signed") return "yes";
  if ((SP_INDEX[p.stage] ?? 0) >= 1) return "venter";
  return "ikke_kontaktet";
}

const CFG = {
  testPrefix: "poutreach",
  stages: SPONSOR_STAGES,
  stageLabel: SPONSOR_STAGE_LABEL,
  stageIndex: SP_INDEX,
  stageFarge: sponsorStageFarge,
  gruppeFor: partnerGruppeFor,
  jaStage: "verbal",
  gjenaapneStage: "dialogue",
  gjenaapneLabel: "Dialog",
  avslagsgrunner: ["Budsjett", "Timing", "Ikke relevant", "Fikk ikke svar", "Annet"],
  navn: (p) => p.company?.name,
  undertekst: (p) => [p.packageName, p.value ? `${kompakt(p.value)} eks. mva` : null, p.company?.contactName].filter(Boolean).join(" · ") || "—",
  sokFelt: (p) => [p.company?.name, p.packageName, p.company?.contactName],
  sokPlaceholder: "Søk selskap, pakke …",
  gruppeSum: (liste) => {
    const s = liste.reduce((a, p) => a + (p.value || 0), 0);
    return s > 0 ? kompakt(s) : null;
  },
  tomTekst: "Ingen partnere i pipelinen ennå",
};

export default function PartnerOutreachListe({ partners, members = [], onOpen, onPatch, onBulkPatch, onBulkDelete }) {
  return <OutreachBase items={partners} members={members} onOpen={onOpen} onPatch={onPatch} onBulkPatch={onBulkPatch} onBulkDelete={onBulkDelete} cfg={CFG} />;
}
